export default __webpack_public_path__ + "static/event-kol-d2de702ba39a45a19a57795f4d4224da.jpg";